import { render, staticRenderFns } from "./left-select.vue?vue&type=template&id=32c1861c&scoped=true"
import script from "./left-select.vue?vue&type=script&lang=js"
export * from "./left-select.vue?vue&type=script&lang=js"
import style0 from "./left-select.vue?vue&type=style&index=0&id=32c1861c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1861c",
  null
  
)

export default component.exports